module.exports = __webpack_public_path__ + "assets/1c2bc4cf81e8b2f6404df5ffae111c2b.mp3";